<template>
<div>
    <h1 class="mb-4 text-gray-500">Ashemaletube Downloader</h1>

    <client-only>
        <template #fallback>
            <el-card shadow="never" :body-style="{padding: '0'}" class="mb-4">
                <div style="height: 100px" class="flex items-center justify-center">
                    <ElIconLoading :width="20" class="mr-2"/>
                    Loading the app
                </div>
            </el-card>
        </template>
        <downloader></downloader>
    </client-only>
    <el-card shadow="never" class="mb-4" :body-style="{ padding: '20px' }">
        <h2 class="text-2xl mb-4">
            Demo video
        </h2>
        <div class="mb-4"> Learn how to get started with Ashemaletube downloader by watching the demo video </div>
        <el-button type="info" size="large" :icon="ElIconVideoPlay" @click="showDemoVideo = true" v-if="!showDemoVideo">Watch video</el-button>

        <video controls autoplay="false" v-show="showDemoVideo">
            <source src="https://anyloader.com/onlyfans_downloader_demo.mp4" type="video/mp4">
            Your browser does not support the video tag.
        </video>
    </el-card>

    <ashemaletube-faq></ashemaletube-faq>
</div>
</template>
<script>
export default {
    created() {
        const siteUrl = useRuntimeConfig().public.siteUrl
        const faqStructuredData = {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
                {
                    '@type': 'Question',
                    name: 'What is Ashemaletube Downloader?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Ashemaletube Downloader is a free Chrome extension that lets you download videos from Ashemaletube for offline viewing. Save videos in their original quality to watch anytime.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'How does Ashemaletube Downloader work?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'The downloader works through a Chrome extension that extracts video URLs from Ashemaletube pages. Simply paste the video URL into the downloader, and it will locate and prepare the video for download.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'Is Ashemaletube Downloader free?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Yes, Ashemaletube Downloader is completely free to use. Just install the Chrome extension and start downloading videos without any hidden fees or subscription requirements.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'Can I download multiple videos at once?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Yes, the downloader supports batch downloads. You can queue multiple Ashemaletube videos and download them sequentially, saving time when collecting multiple videos.'
                    }
                }
            ]
        }

        useHead({
            title: 'Free Ashemaletube Downloader - Download Videos from Ashemaletube',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Download videos from Ashemaletube for free using our Chrome extension. Save videos in original quality for offline viewing. Batch download support available.',
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: 'ashemaletube downloader, download ashemaletube videos, ashemaletube video downloader, free ashemaletube downloader, ashemaletube chrome extension'
                }
            ],
            link: [
                {rel: 'canonical', href: siteUrl + '/ashemaletube-downloader'}
            ],
            script: [
                {
                    type: 'application/ld+json',
                    children: JSON.stringify(faqStructuredData)
                }
            ]
        })
    },
    data () {
        return {
            showDemoVideo: false
        }
    }
}
</script>